import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Badge } from "Components/Base/DataDisplay/Badge";
import TotalProgressSection from "./components/TotalProgressSection";
import DrawerFilters from "./components/DrawerFilters";
import ButtonFilter from "./components/ButtonFilter";

const MobileFilter = ({
  store,
  mediaClass,
  languageContext,
  setFilter,
  setSortBy,
  setSearchText,
  onSearch,
  state,
  setState,
  hitCount,
  totalPercentCompleted,
}) => (
  <>
    <BaseGrid
      alignItems="center"
      justifyContent="space-between"
      childWidth="auto"
    >
      <Badge badgeContent={hitCount ?? 0} color="primary">
        <ButtonFilter
          state={state}
          setState={setState}
          languageContext={languageContext}
        />
      </Badge>

      <TotalProgressSection
        totalPercentCompleted={totalPercentCompleted}
        languageContext={languageContext}
        scale={0.8}
      />
    </BaseGrid>

    <DrawerFilters
      state={state}
      setState={setState}
      store={store}
      mediaClass={mediaClass}
      hitCount={hitCount}
      languageContext={languageContext}
      setSearchText={setSearchText}
      setSortBy={setSortBy}
      setFilter={setFilter}
      onSearch={onSearch}
      mobile={true}
    />
  </>
);

export default MobileFilter;
